import React from 'react'
import { format } from 'date-fns'
import { getBillingToken } from '~/tools/stripe'
import { subscribe } from "~/redux/user/subscription";
import { updateUserCard, updateStripePayment } from "~/redux/user/helpers";
import getSymbolFromCurrency from 'currency-symbol-map'
import _ from 'lodash'

import StripeCCForm from './StripeCCForm'
import SSLCommerz from '~/components/SSLCommerz'
import CCAvenueNS from '~/components/CCAvenueNS2'
import AcceptedPayments from '../AcceptedPayments'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'

import { getLegalTexts } from '../../Purchase/helper'

import './style.css'

class Billing extends React.Component {
  constructor(props) {
    super(props)
    this.state = { form: null }
  }

  componentDidMount() {
    if(this.props.paymentHandler){
      this.setState({ form: this.props.paymentHandler })
    } else {
      getCountryCode().then(country => {
        var k = null, providers = window.settings.paymentProviders

        for (k in providers) {
          if (_.includes(providers[k].country, country)) {
            return this.setState({ form: k })
          }
        }
        for (k in providers) {
          if (_.includes(providers[k].country, 'ROW')) {
            return this.setState({ form: k })
          }
        }
        console.log('Error. Payment ROW not found. Defaulting to stripe')
        return this.setState({ form: 'stripe' })
      })      
    }
  }

  render() {
    if (!this.state.form)
      return null;

    var searchParams = (new URL(document.location)).searchParams
    var override = searchParams && searchParams.get('paymentMethod')
    var form = override || this.state.form
    // return(
    //   form === 'stripe' ? this.stripeForm() : this.ccavForm()
    // )
    switch(form){
      case 'ccavenue':
        return (this.ccavForm())
      case 'sslcommerz':
        return (this.sslForm())
      default:
        return (this.stripeForm())
    }
  }

  offerCodeEl() {
    return (
      <div className="offer-code">
        <i className="ion-ios-pricetags-outline"></i>
        { this.props.offerCode ? (
          <span>Offer Code "{ this.props.offerCode.displayName || this.props.offerCode.name }" Applied </span>
        ) : (
          <span>No Code Applied</span>
        ) }
        <span className="link-button site-color site-border-color" onClick={ _ => this.props.editPromo() }>Edit</span>
      </div>
    )
  }

  stripeForm() {
    const { plan, editPlan } = this.props
    const pd = plan.planDetails && plan.planDetails[0]

    return <div className="billing stripe-container">
        <div className="plan-title">
          {plan.name}
          { editPlan && 
            <span className="link-button site-color site-border-color edit-plan" onClick={() => editPlan()}>
             Edit
            </span> }
        </div>
        <div className="plan-details">{plan.description}</div>
        {this.props.firstPayment && <div className="desc">
            <span className="first-payment">First Payment</span>
            <span className="price">
              &nbsp;
              {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
              {this.props.firstPayment.amount.toFixed(2)}
            </span> (+ tax if req'd) on {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
          </div>}
        <AcceptedPayments />
        {this.offerCodeEl()}

        <StripeCCForm onToken={token => {
            if(this.props.updateCard) {
              let userObj = this.props.user;
              userObj.billingInfo = {stripeToken: token}
              updateUserCard(userObj);
              return updateStripePayment(token).then(data => {
                if(this.props.purchase){
                  this.props.success(data)
                } else {
                  subscribe({
                    plan: this.props.plan,
                    billingToken: {stripeToken: token},
                    offerCode:
                      this.props.offerCode &&
                      this.props.offerCode.code
                  })
                  this.props.success(data);
                }
              })
            } else {
              return getBillingToken(token)
              .then(billingToken => {
                let userObj = this.props.user;
                userObj.billingInfo = billingToken;
                updateUserCard(userObj);
                if (this.props.purchase) {
                  this.props.saveToken(billingToken);
                } else {
                  subscribe({
                    plan: this.props.plan,
                    billingToken: billingToken,
                    offerCode:
                      this.props.offerCode && this.props.offerCode.code
                  });
                }
              })
              .then(data => this.props.success(data));
            }
          }} submitCaption={this.props.updateCard ? "Save Changes" : (this.props.buttonCaption || "Subscribe Now")} />
        {getLegalTexts(window.settings.internalName, this.props.subscription, this.props.plan.option, window.settings.companyName)}
      </div>;
  }

  ccavForm() {
    var plan = this.props.plan
    var pd = plan.planDetails[0]

    return (
      <div className="billing ccav-container">
        <div className="plan-info">
          <div className="title">
            { plan.name }
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={ () => this.props.editPlan() }>
              Edit
            </span>
          </div>
          <div className="desc">
            <span className="first-payment">First Payment</span>
            &nbsp;{ getSymbolFromCurrency(pd.recurringPaymentCurrencyCode) }{ pd.recurringPaymentAmount } on { format(Date.now(), 'MM/DD/YYYY') }
          </div>
          <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            { this.props.offerCode ? (
              <span>Offer Code "{ this.props.offerCode.displayName || this.props.offerCode.name }" Applied </span>
            ) : (
              <span>Have a code?</span>
            ) }
            <span className="link-button site-color site-border-color" onClick={ _ => this.props.editPromo() }>
              { this.props.offerCode ? 'Edit' : 'Add' }
            </span>
          </div>
        </div>
        <CCAvenueNS plan={ plan } />
      </div>
    )
  }

  sslForm() {
    var plan = this.props.plan
    var pd = plan.planDetails[0]

    return (
      <div className="billing ccav-container">
        <div className="plan-info">
          <div className="title">
            { plan.name }
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={ () => this.props.editPlan() }>
              Edit
            </span>
          </div>
          <div className="desc">
            <span className="first-payment">First Payment</span>
            &nbsp;{ getSymbolFromCurrency(pd.recurringPaymentCurrencyCode) }{ pd.recurringPaymentAmount } on { format(Date.now(), 'MM/DD/YYYY') }
          </div>
          <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            { this.props.offerCode ? (
              <span>Offer Code "{ this.props.offerCode.displayName || this.props.offerCode.name }" Applied </span>
            ) : (
              <span>Have a code?</span>
            ) }
            <span className="link-button site-color site-border-color" onClick={ _ => this.props.editPromo() }>
              { this.props.offerCode ? 'Edit' : 'Add' }
            </span>
          </div>
        </div>
        <SSLCommerz plan={ plan } />
      </div>
    )
  }
}

export default Billing;
